import styled from "styled-components";
import happyGirl from "assets/images/Elle_Tiffany_2021_04_210929_1.gif";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  max-width: 1342px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 128px 0;

  @media screen and (max-width: 580px) {
    padding: 80px 0;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 96px;

  @media screen and (max-width: 580px) {
    padding: 0 32px;
  }
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 470px;
  margin: 0 auto 124px auto;
  font-family: ${fonts.BentonSansWide};
  font-size: 35px;
  line-height: 45px;
  text-align: center;

  @media screen and (max-width: 1680px) {
    font-size: 28px;
    line-height: 38px;
    max-width: 550px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 24px;
    line-height: 34px;
  }

  @media screen and (max-width: 414px) {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 48px;
  }

  @media screen and (max-width: 320px) {
    font-size: 14px;
    line-height: 24px;
  }
`;

export const Text = styled.article`
  font-size: 28px;
  line-height: 32px;
  text-align: justify;

  @media screen and (max-width: 1680px) {
    font-size: 24px;
    line-height: 28px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 22px;
    line-height: 26px;
  }

  @media screen and (max-width: 1024px) {
    font-size: 20px;
    line-height: 24px;
  }

  @media screen and (max-width: 580px) {
    font-size: 18px;
    line-height: 22px;
  }

  @media screen and (max-width: 375px) {
    font-size: 16px;
    line-height: 20px;
  }

  @media screen and (max-width: 320px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const About = styled.div`
  &.mobile {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    &.mobile {
      display: block;
    }

    &.web {
      display: none;
    }
  }
`;

export const HappyGirl = styled.img.attrs({ src: happyGirl })`
  width: 100%;
  height: auto;
  object-fit: contain;
  margin: 128px 0;
  padding: 0 96px;

  @media screen and (max-width: 1024px) {
    padding: 0;
  }

  @media screen and (max-width: 580px) {
    margin: 80px 0;
  }
`;

export const Video = styled.div`
  display: flex;
  align-items: center !important;
  width: 100%;
  height: 80vh;
  position: relative;
  overflow: hidden;
  margin-top: 128px;
  padding: 0 96px;

  /* background-color: #ccc;
  min-height: 100vh;
  justify-content: center;
  color: #ccc;
  font-size: 40px;
  font-family: ${fonts.BentonSansWideBlack}; */

  /* video {
    width: 100%;
    height: 80vh;
    object-fit: cover;
  } */

  @media screen and (max-width: 580px) {
    margin-top: 80px;
    padding: 0;
  }
`;
